import React from 'react';
import styled from 'styled-components';

import Footer from 'SharedComponents/footer';

//import styles from './index.css';
import styles from './index.css.js';

//const FAQWrapper = styled.div`${styles}`;
//const FinancialServicesGuideWrapper = styled.section`${styles}`;
const FinancialServicesGuideWrapper = styled.div`${styles}`;


const FinancialServicesGuide = () => (
  <FinancialServicesGuideWrapper>
    <div className="content">
      <div className="content-container" style={{ minHeight: 'calc(100vh - 400px)' }}>
        <h1>Financial Services Guide</h1>

        <br />
        <h2>Introduction</h2>
        <p>This Financial Services Guide (FSG) is issued by Alethia Partners Pty Ltd, Australian Financial Services Licence (AFSL) No. 557729 (“Alethia”).</p>
        <p>This FSG is designed to assist you in determining whether to use any of the services offered by Alethia or A.C.N. 631 200 425 Pty Ltd (ABN 30 631 200 425) (Corporate Authorised Representative Number 1296717) t/a Boost Your Super of 10 Beresford Street Caulfield North Victoria  3161</p>
        <p>Boost Your Super is an authorised representative of Alethia and has been given permission to provide you with this FSG.  It contains information about: 
          <ul>
            <li>Alethia, who as the Licensee, is responsible for the financial services you receive.</li>
            <li>The financial services Boost Your Super can provide.</li>
            <li>How Boost Your Super, and other related parties are paid for the services provided to you.</li>
            <li>Any associations or relationships that could create potential conflicts of interest.</li>
            <li>Details of who to contact should you have a complaint.</li>
          </ul>
        </p>

        <p style={{backgroundColor: '#EFEFEF', padding: '20px' }}><b>Lack of Independence:</b> We confirm that neither Alethia nor Boost Your Super are independent, impartial or unbiased as Alethia receives insurance commissions.</p>

        <p>You can contact Boost Your Super
          <ul>
            <li>by email: accounts@boostyoursuper.com.au or</li>
            <li>by telephone:  0402 763 88.</li>
          </ul> 
        </p>

        <h2>What kinds of financial services is Boost Your Super authorised to provide me?</h2>
        <p>Boost Your Super can provide general advice only in the following areas:</p>
        <ul>
          <li>Basic Deposits</li>
          <li>Superannuation (including Self-Managed Super Funds).</li>
        </ul>

        <h2>General advice warning</h2>
        <p>Note that general advice does not take account of your objectives, financial situation or needs.
        You should seek advice from a licensed financial planner should you wish to receive personal advice.
        </p>

        <h2>How will I pay for the service?</h2>
        <p>Boost Your Super does not charge for the provision of general financial advice. Further, Boost Your Super does not charge you for signing up and using the cash back service available on the Boost Your Super platform</p>
        <p>Boost Your Super earns a referral commission when you click through to and make a purchase from the shops listed on its platforms (including Boost Your Super’s Website, Apps and Browser Extensions). Boost Your Super takes between 0% and 50% of the referral commission earned depending on any Bonus Boost offers that may be present at the time of purchase and our members’ Boost Power. The amount of commission you earn is displayed against each shop on the Boost Your Super website and ranges usually between 0% and 5% of the amount of your purchases.  This commission is not a cost to you. </p>
        <p>Boost Your Super reserves the right to vary commission rates at its discretion. Neither Alethia or Boost Your Super accepts any form of conflicted remuneration.</p>

        <h2>What other benefits may product providers give to Alethia or Boost Your Super?</h2>
        <p>Some product providers may give Alethia or Boost Your Super other benefits such as entertainment or sponsorship. Alethia maintains a Register in line with industry standards to document any benefits received. </p>

        <h2>Privacy</h2>
        <p>We keep a record of a personal profile, which may include your name, email, date of birth, address, phone number and the details of your superannuation fund. We also keep a record of your transactions made through the Boost Your Super platform including the status and amount of cash back earned with each purchase.</p>
        <p>As a financial service provider, we have an obligation under the Anti Money Laundering and Counter Terrorism Finance Act to verify your identity and the source of any funds. This means that we may ask you to present identification documents such as passports and driver’s licence. We will also retain copies of this information. We assure you that this information will be held securely. We cannot provide you with services if you are unwilling to provide this information. </p>

        <p>We are committed to your privacy and the security of your personal information. We implement this through our privacy policy which is readily available on our website.</p>
        <p>Most of the information we hold on you is available within your Boost Your Super account and can be found by logging in.</p>


        <h2>What should you do if you are not satisfied with our services?</h2>
        <p>If you have any complaints about the services provided contact us by email: accounts@boostyoursuper.com.au or by telephone:  0402 763 88. </p>
        <p>If your complaint is not satisfactorily resolved within 5 working days, please contact Alethia’s Compliance Team by email:  compliance@alethiapartners.com.au or  by telephone:08 9242 3053.  Alethia will try to resolve your complaint quickly and fairly. </p>
        <p>If an issue has not been resolved to your satisfaction, you can lodge a complaint with the Australian Financial Complaints Authority (AFCA). AFCA provides financial services complaint resolution that is free to consumers. Alethia is a member of AFCA.  </p>
          <ul>
            <li>Website: www.afca.org.au </li>
            <li>Email: info@afca.org.au </li>
            <li>Telephone: 1800 931 678 (free call)</li>
            <li>In writing to: Australian Financial Complaints Authority, GPO Box 3, Melbourne VIC 3001 </li> 
          </ul>

          <h2>Compensation arrangements</h2>
          <p>Alethia confirms that it has arrangements in place to ensure it continues to maintain Professional Indemnity insurance in accordance with s.912B of the Corporations Act 2001 (as amended).  Our Professional Indemnity insurance, subject to its terms and conditions, provides indemnity up to the sum insured for Alethia and our authorised representatives in respect of our authorisations and obligations under our AFSL. This insurance will continue to provide such coverage for any authorised representative that has ceased work with Alethia for work done whilst engaged with us.</p>

          <p>
            Issued by:<br/>
            Alethia Partners Pty Ltd<br/>
            ABN 98 676 423 117 | AFSL 557729<br/>
            Unit 4, 16 Nicholson Road<br/>
            Subiaco WA 6008<br/>
            Phone: 08 9242 3053<br/>
            Email: compliance@alethiapartners.com.au<br/>
            Date: 02 February 2026<br/>
          </p>
        
        <h2>Contacting us</h2>
        <p>Boost Your Super welcomes your comments regarding this Financial Services Guide. If you have any questions about this Privacy Policy and would like further information, please contact us by any of the following means during business hours Monday to Friday.</p>

        <p><b>Email:&nbsp;</b><a href="mailto:admin@boostyoursuper.com.au">admin@boostyoursuper.com.au</a></p>
      </div>
    </div>
    <Footer />
  </FinancialServicesGuideWrapper>
);

export default FinancialServicesGuide;
